export function removeBaseHrefFromPathname(reqUrl: string, baseHref: string): string {
  if (baseHref !== '/' && reqUrl.startsWith(baseHref)) {
    return reqUrl.replace(baseHref, '/');
  }
  return reqUrl;
}
